import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, ConfirmationModal, Typography } from 'seagull';
import ExternalLinkButton from '~/components/ExternalLinkButton';
const IMPORT_FORM_URL = 'https://forms.gle/Q9sMHXFcp5Fs866FA';
export const ImportDraftsModal = (param)=>{
    let { texts, closeButtonTestId, noteClassName, dismissModal } = param;
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'drafts_confirm'
            },
            secondaryButton: {
                name: 'drafts_cancel'
            }
        },
        textAlignCenter: false,
        primaryButtonLabel: texts.close(),
        onPrimaryButtonClick: dismissModal,
        onCloseButtonClick: dismissModal,
        title: texts.title(),
        primaryButtonTestId: closeButtonTestId,
        content: /*#__PURE__*/ _jsxs(Box, {
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    children: texts.intro()
                }),
                /*#__PURE__*/ _jsxs(Typography, {
                    children: [
                        /*#__PURE__*/ _jsx(ExternalLinkButton, {
                            openInNewTab: true,
                            href: IMPORT_FORM_URL,
                            bi: {
                                name: 'import_drafts_complete_form'
                            },
                            children: texts.completeForm()
                        }),
                        ' ',
                        texts.outro()
                    ]
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph2",
                    className: noteClassName,
                    children: texts.note()
                })
            ]
        })
    });
};
